import { lazy } from "react";
import { DefaultLayout } from "../../layout";
import { withSuspense } from "../../routes/helpers";

const CreateProjectSuperAdmin = lazy(() => import("./CreateProjectSuperAdmin"));
const EditProjectSuperAdmin = lazy(() => import("./EditProjectSuperAdmin"));
const ViewProjectsSuperAdmin = lazy(() => import("./ViewProjectsSuperAdmin"));
const ViewProject = lazy(() => import("./ViewProject"));
const EditProject = lazy(() => import("./EditProject"));
const ViewProjectStructure = lazy(() => import("../project-structure/ViewProjectStructure"));
const ViewProjectSupplier = lazy(() => import("../project-supplier/ViewProjectSupplier"));
const ViewProjectFile = lazy(() => import("../project-file/ViewProjectFile"));
const ViewProjectFileMultipleMaster = lazy(() => import("../project-file/ViewProjectFileMultipleMaster"));
const ProjectStructureDetail = lazy(() => import("../project-structure/ProjectStructureDetail"));
const ProjectSupplierDetail = lazy(() => import("../project-supplier/ProjectSupplierDetail"));
const ProjectFileDetail = lazy(() => import("../project-file/ProjectFileDetail"));
const CreateProjectStructure = lazy(() => import("../project-structure/CreateProjectStructure"));
const CreateProjectSupplierConfig = lazy(() => import("../project-supplier/CreateProjectSupplierConfig"));
const CreateProjectFileConfig = lazy(() => import("../project-file/CreateProjectFileConfig"));
const CreateProjectFileConfigMultipleMaster = lazy(() => import("../project-file/CreateProjectFileConfigMultipleMaster"));

const L = DefaultLayout;
const W = withSuspense;

function projectRoute(path, element) {
  return { path, layout: L, element };
}

export function getProjectSuperadminRoutes() {
  return [
    projectRoute("/create-project-superadmin", W(CreateProjectSuperAdmin)),
    projectRoute("/view-projects-superadmin", W(ViewProjectsSuperAdmin)),
    projectRoute("/project-superadmin/:id/edit", W(EditProjectSuperAdmin)),
    projectRoute("/project-superadmin/:id", W(ViewProject)),
    projectRoute("/project/:id", W(ViewProject)),
    projectRoute("/project/:id/structure", W(ViewProjectStructure)),
    projectRoute("/project/:id/supplier", W(ViewProjectSupplier)),
    projectRoute("/project/:id/file", W(ViewProjectFile)),
    projectRoute("/project/:id/file-multiple", W(ViewProjectFileMultipleMaster)),
    projectRoute("/project/:id/file-multiple/create", W(CreateProjectFileConfigMultipleMaster)),
    projectRoute("/project/:id/file-multiple/:fid/edit", W(CreateProjectFileConfigMultipleMaster)),
    projectRoute("/project/:id/file-multiple/:fid/:clone", W(CreateProjectFileConfigMultipleMaster)),
    projectRoute("/project/:id/file-multiple/:fid/detail", W(ProjectFileDetail)),
    projectRoute("/project/:id/structure/create", W(CreateProjectStructure)),
    projectRoute("/project/:id/supplier/create", W(CreateProjectSupplierConfig)),
    projectRoute("/project/:id/file/create", W(CreateProjectFileConfig)),
    projectRoute("/project/:id/structure/:sid/detail", W(ProjectStructureDetail)),
    projectRoute("/project/:id/supplier/:sid/detail", W(ProjectSupplierDetail)),
    projectRoute("/project/:id/file/:fid/detail", W(ProjectFileDetail)),
    projectRoute("/project/:id/edit", W(EditProject)),
    projectRoute("/project/:id/structure/:sid/edit", W(CreateProjectStructure)),
    projectRoute("/project/:id/supplier/:sid/edit", W(CreateProjectSupplierConfig)),
    projectRoute("/project/:id/file/:fid/edit", W(CreateProjectFileConfig)),
    projectRoute("/project/:id/structure/:sid/:clone", W(CreateProjectStructure)),
    projectRoute("/project/:id/file/:fid/:clone", W(CreateProjectFileConfig)),
  ];
}

export function getProjectAdminOrUserRoutes() {
  return [
    projectRoute("/project/:id", W(ViewProject)),
    projectRoute("/project/:id/structure", W(ViewProjectStructure)),
    projectRoute("/project/:id/supplier", W(ViewProjectSupplier)),
    projectRoute("/project/:id/file", W(ViewProjectFile)),
    projectRoute("/project/:id/file-multiple", W(ViewProjectFileMultipleMaster)),
    projectRoute("/project/:id/file-multiple/create", W(CreateProjectFileConfigMultipleMaster)),
    projectRoute("/project/:id/file-multiple/:fid/edit", W(CreateProjectFileConfigMultipleMaster)),
    projectRoute("/project/:id/file-multiple/:fid/:clone", W(CreateProjectFileConfigMultipleMaster)),
    projectRoute("/project/:id/file-multiple/:fid/detail", W(ProjectFileDetail)),
    projectRoute("/project/:id/structure/create", W(CreateProjectStructure)),
    projectRoute("/project/:id/supplier/create", W(CreateProjectSupplierConfig)),
    projectRoute("/project/:id/file/create", W(CreateProjectFileConfig)),
    projectRoute("/project/:id/structure/:sid/detail", W(ProjectStructureDetail)),
    projectRoute("/project/:id/supplier/:sid/detail", W(ProjectSupplierDetail)),
    projectRoute("/project/:id/file/:fid/detail", W(ProjectFileDetail)),
    projectRoute("/project/:id/edit", W(EditProject)),
    projectRoute("/project/:id/structure/:sid/edit", W(CreateProjectStructure)),
    projectRoute("/project/:id/supplier/:sid/edit", W(CreateProjectSupplierConfig)),
    projectRoute("/project/:id/file/:fid/edit", W(CreateProjectFileConfig)),
    projectRoute("/project/:id/structure/:sid/:clone", W(CreateProjectStructure)),
    projectRoute("/project/:id/file/:fid/:clone", W(CreateProjectFileConfig)),
  ];
}
